import { Component, forwardRef } from "@angular/core";
import { ModelService } from "../../../../Services/model.service";
import { StartAction } from "../../../../Model/Dto/StartAction";
import { UserActionBaseComponent } from "../userAction-base.component";
import { TranslateService } from "@ngx-translate/core";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { JobService } from "app/Services/job.service";
import { LoginService } from "app/Services/login.service";


@Component({
    selector: "userAction-setMimePurpose",
    templateUrl: "userAction-setMimePurpose.component.html",
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionSetMimePurposeComponent) }
    ],
    standalone: false
})
export class UserActionSetMimePurposeComponent extends UserActionBaseComponent {
  
  overrideExisting: boolean = false;


  constructor(public loginService: LoginService, public macroService: MacroService, public jobService: JobService, public translate: TranslateService, public catalogService: CatalogService) {
    super(loginService, macroService);
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.overrideExisting = parsed.overrideExisting;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  createParameterStringAsJsonString(): string {
    return JSON.stringify({ OverrideExisting: this.overrideExisting });
  }
}
